var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m39.3 17.8.4-1.4-1.1-1H40l.5-1.3.5 1.4h1.5l-1.2.9.4 1.4-1.2-.9m2.3 1.1.8-1.1-.8-1.3 1.4.5 1-1.1v1.4l1.3.6-1.4.4v1.5l-1-1.2M36 18.9v-1.4l-1.5-.5 1.4-.5v-1.4l1 1 1.3-.4-.8 1.2.9 1.2-1.5-.4m-3.3 3.4-.6-1.3-1.4.2 1-1-.5-1.4 1.3.7 1-1-.2 1.4 1.2.8-1.4.2m-1.5 4.6-1-1-1.3.9.5-1.4-1-1H31l.5-1.3.4 1.4 1.4.2-1.2.8m.3 5-1.4-.4-.8 1.2v-1.5l-1.5-.4 1.4-.6v-1.5L31 26l1.3-.4-.8 1.2M34 31l-1.4.2-.3 1.5-.7-1.4-1.4.2 1-1-.6-1.4 1.3.7 1-1-.2 1.5m3.8 3.1-1.3.7.3 1.5-1.1-1-1.3.6.6-1.3-1-1.1 1.4.2.7-1.3.3 1.5m4.5.7-.7 1.3 1 1-1.5-.2-.8 1.3-.2-1.5-1.4-.3 1.3-.6-.1-1.5 1 1m4.8-1v1.4l1.3.6-1.4.4-.1 1.4L42 36l-1.5.3 1-1.1-.8-1.3 1.3.5m4.6-17 1 1.1 1.3-.6-.7 1.3 1 1.1-1.4-.2-.8 1.3-.2-1.5-1.4-.3 1.3-.6m2.9 1.7.4 1.4h1.5l-1.2 1 .4 1.3-1.2-.8-1.2.8.5-1.4-1.2-.9h1.5m1.6 2.8-.2 1.4 1.3.7-1.4.3-.2 1.4-.8-1.3-1.4.3 1-1.1-.7-1.3 1.4.6m.2 3.3-.6 1.3 1 1-1.5-.1-.7 1.2-.3-1.4-1.4-.3 1.3-.6-.2-1.5 1 1m-.8 3.3-1.2.8.3 1.4-1-1-1.3.8.5-1.4-1.1-1 1.4.1.6-1.3.4 1.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h26.7v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.1 0 10.2 7.5L23.4 0h3.3v2.6l-10 7.4 10 7.5V20h-3.4l-10-7.5-10 7.5H0v-2.5l10-7.4L0 2.7V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m17.7 11.7 9 6.6V20l-11.3-8.3zm-7.7.8.2 1.5-8 6H0zM26.7 0v.1L16.3 8V6l8.4-6zM0 0l10 7.3H7.5L0 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 0v20h6.7V0zM0 6.7v6.6h26.7V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 8v4h26.7V8zm11.4-8v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCk);
export default __webpack_public_path__ + "static/media/ck.728003a57e5c024a869cabea64ee97b0.svg";
export { ForwardRef as ReactComponent };